import React from 'react';
import { InputLabel, TooltipProps } from '@chargify/custom-ui-components';

import { Container } from './HostedField.styles';

export type HostedFieldProps = {
  /**
   * React children nodes
   */
  children?: React.ReactNode;
  /**
   * Label content
   */
  label: string;
  /**
   * Required field
   */
  required?: boolean;
  /**
   * Field error
   */
  hasError?: boolean;
  /**
   * Tooltip settings
   */
  tooltip?: Omit<TooltipProps, 'children'>;
};

const HostedField = ({
  label,
  required,
  tooltip,
  children,
}: HostedFieldProps) => (
  <Container gridRowGap={1}>
    <InputLabel
      label={label}
      size="small"
      required={required}
      tooltip={tooltip}
      textEllipsis={true}
      flexLabel={true}
    />
    {children}
  </Container>
);

export default HostedField;
